import React from 'react';
import { Typography, Card, CardHeader, CardContent, Table, TableHead, TableBody, Stack, Box } from '@mui/material';
import RichTooltip from '../../RichTooltip';
import BreakdownRow from './BreakdownRow';
import BreakdownHeaderRow from './BreakdownHeaderRow';

const UnsubscribeBreakdownCard = ({ a, b, showB, text, icon, periodColours, selectedPeriods }) => {
    return (
        <Card sx={{ height: '100%' }}>
            <CardHeader
                avatar={icon}
                title={text}
                slotProps={{
                    title: {
                        variant: 'body1'
                    }
                }}
                sx={{
                    m: 0,
                    p: 1,
                    '& .MuiCardHeader-action': {
                        m: 0
                    },
                    '& .MuiCardHeader-avatar': {
                        mr: 1
                    }
                }}
                action={(
                    <RichTooltip>
                        <Stack spacing={2}>
                            <Box>
                                <Typography variant="body1" sx={{ pb: 0.5 }}>Recipient Unsubscribes</Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>Via the email itself or the email reader</Typography>
                                <Typography variant="body1" sx={{ pb: 0.5, mt: 1 }}>System Unsubscribes</Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>From a deliverability issue such as too many bounces</Typography>
                            </Box>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>Accurate to 3 decimal places</Typography>
                        </Stack>
                    </RichTooltip>
                )}
            />
            <CardContent
                sx={{
                    m: 0,
                    p: 0,
                    '&:last-child': {
                        paddingBottom: 0
                    }
                }}
            >
                <Table size="small">
                    <TableHead>
                        <BreakdownHeaderRow
                            showB={showB}
                            aLabel="Period A:"
                            bLabel="Period B:"
                            aDate={selectedPeriods ? selectedPeriods[0] : null}
                        />
                    </TableHead>
                    <TableBody>
                        <BreakdownRow
                            a={a.averageUnsubscribeRate * 100}
                            b={b?.averageUnsubscribeRate * 100}
                            showB={showB}
                            periodColours={periodColours}
                            text="Total"
                        />
                        <BreakdownRow
                            a={a.averageUnsubscribeRate > 0 ? Math.abs(a.averageUnsubscribeRate - a.averageHardBounceRate) * 100 : 0}
                            b={b?.averageUnsubscribeRate > 0 ? Math.abs(b.averageUnsubscribeRate - b.averageHardBounceRate) * 100 : 0}
                            showB={showB}
                            periodColours={periodColours}
                            text="Recipient"
                        />
                        <BreakdownRow
                            a={a.averageHardBounceRate * 100}
                            b={b?.averageHardBounceRate * 100}
                            showB={showB}
                            periodColours={periodColours}
                            text="System"
                        />
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

export default UnsubscribeBreakdownCard;